import { RadioCard } from "components/common/RadioCard";
import {
  RepaymentHolidaysType,
  SelectedTreatmentsDetails,
} from "domain/selectedTreatments";
import { useCallback } from "react";
import {
  CIRH,
  CRH,
  REPAYMENT_HOLIDAY_OPTION_CIRH_TEXT,
  REPAYMENT_HOLIDAY_OPTION_CRH_TEXT,
  REPAYMENT_HOLIDAY_OPTION_LABEL,
} from "./RequestRepaymentHoliday.const";

type RepaymentHolidayOptionsProps = {
  selectedTreatments: SelectedTreatmentsDetails;
  onChange: (selectedTreatments: SelectedTreatmentsDetails) => void;
  onChecked: (checked: boolean) => void;
};
export const RepaymentHolidayOptions = ({
  selectedTreatments,
  onChange,
  onChecked,
}: RepaymentHolidayOptionsProps) => {
  const isCRHSelected =
    selectedTreatments.selectedRHType ===
    RepaymentHolidaysType.CapitalRepaymentHoliday;
  const isCIRHSelected =
    selectedTreatments.selectedRHType ===
    RepaymentHolidaysType.CapitalIntersestRepaymentHoliday;
  const handleChange = useCallback(
    (selectedOptionType: RepaymentHolidaysType) => {
      onChange({
        ...selectedTreatments,
        selectedRHType: selectedOptionType,
        selectedOptionType: null,
        repaymentOption: null,
      });
      onChecked(false);
    },
    [onChange, onChecked, selectedTreatments]
  );
  return (
    <div className="available-options section-margin">
      <label id="repaymentOptions" className="title">
        {REPAYMENT_HOLIDAY_OPTION_LABEL}
      </label>
      <fieldset aria-labelledby="repaymentOptions">
        <RadioCard
          name="repaymentOptions"
          isSelected={isCRHSelected}
          value={selectedTreatments.selectedRHType}
          onChange={() =>
            handleChange(RepaymentHolidaysType.CapitalRepaymentHoliday)
          }
          label={CRH}
        >
          <div>{REPAYMENT_HOLIDAY_OPTION_CRH_TEXT}</div>
        </RadioCard>
        <RadioCard
          name="repaymentOptions"
          isSelected={isCIRHSelected}
          value={selectedTreatments.selectedRHType}
          onChange={() =>
            handleChange(RepaymentHolidaysType.CapitalIntersestRepaymentHoliday)
          }
          label={CIRH}
        >
          <div>{REPAYMENT_HOLIDAY_OPTION_CIRH_TEXT}</div>
        </RadioCard>
      </fieldset>
    </div>
  );
};
